import { coreApi } from '@cp/shared/api/core';
import { ClientAudioCreateRequest, ClientAudioCreateResponse } from '@common/model/client/audio/request';
import { ClientAudioResponse } from '@common/model/client/audio/response';
import { CoreClientAudioApiTags, coreClientAudioApiTagTypes } from './tags';

export const coreClientAudioApi = coreApi.enhanceEndpoints({ addTagTypes: coreClientAudioApiTagTypes }).injectEndpoints({
  endpoints: (builder) => ({
    uploadAudio: builder.mutation<ClientAudioCreateResponse, ClientAudioCreateRequest>({
      query: (data) => ({
        url: '/client/audio',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [CoreClientAudioApiTags.ClientAudio],
    }),
    getClientAudio: builder.query<ClientAudioResponse[], void>({
      query: () => ({
        url: '/client/audio',
        method: 'GET',
      }),
      providesTags: [CoreClientAudioApiTags.ClientAudio],
    }),
    deleteClientAudio: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `/client/audio/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CoreClientAudioApiTags.ClientAudio],
    }),
  }),
  overrideExisting: false,
});
